import { useMutation } from "@apollo/client"
import { CreateIntegrationSourceDocument } from "@hydrologiq/gql-experience/graphql"
import { usePrimaryClientIfAvailable } from "../../providers/DualGraphQLProvider"

export const useCreateIntegrationSource = () => {
  const client = usePrimaryClientIfAvailable()
  const [createSource, { loading, error }] = useMutation(CreateIntegrationSourceDocument, { client })

  return {
    createSource,
    loading,
    error,
  }
}
